/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { GlobalError } from '../../GlobalError/GlobalError';
import { TabsPageRouteElement } from './TabsPageRouteElement';
export function mapGlobalAppRouteObject(route, basename) {
    const mapFunction = 'handle' in route && route.handle && route.handle.type ? mapFunctions[route.handle.type] : undefined;
    if (mapFunction) {
        return mapFunction(route, basename);
    }
    else {
        return route;
    }
}
const mapFunctions = {
    page: (route) => {
        var _a;
        return Object.assign(Object.assign({}, route), { errorElement: (_a = route.errorElement) !== null && _a !== void 0 ? _a : React.createElement(GlobalError, null) });
    },
    tabs: (route, basename) => {
        var _a;
        return Object.assign(Object.assign({}, route), { element: React.createElement(TabsPageRouteElement, { route: route, basename: basename }), errorElement: (_a = route.errorElement) !== null && _a !== void 0 ? _a : React.createElement(GlobalError, null) });
    },
};
